import { useEffect } from "react";
import { queryAlipay } from "../../api/order";
import { useNavigate } from "react-router";
const Alipay = () => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  /**
   * 支付宝回调，同步查询支付宝支付状态
   */
  const queryAli = async () => {
    let params: { [key: string]: string } = {};
    queryParams.forEach(function (value, key) {
      params[key] = value;
    });
    const res = await queryAlipay(params);
    if (res.code === 0) {
      navigate("/result?transaction_id=" + params.out_trade_no);
    }
  };

  useEffect(() => {
    queryAli();
  }, []);
  return <div></div>;
};

export default Alipay;
